import Component from '@glimmer/component'
import { tracked } from '@glimmer/tracking'
import { action } from '@ember/object'
import { SubscriptionType } from 'teacher-ui-client/subscription-type/subscription-types'
import { PrintablesBookRole } from 'teacher-ui-client/components/printables/roles'
import type { PrintablesLibrarySetEntry } from 'teacher-ui-client/contentful-client/entry-types'
import { fn } from '@ember/helper'
import { on } from '@ember/modifier'
import { t } from 'ember-intl'
import ResourceCardBook from 'teacher-ui-client/components/printables/resource-card/book'

interface Signature {
  Element: HTMLDivElement
  Args: {
    subscriptionType?: SubscriptionType
    bookSet: PrintablesLibrarySetEntry
  }
}

const { Student, Teacher } = PrintablesBookRole

export class ResourceCard extends Component<Signature> {
  @tracked currentlyActiveTab = this.hasStudentResource ? Student : Teacher

  get studentResourceTabIsActive() {
    return this.currentlyActiveTab === Student
  }

  get teacherResourceTabIsActive() {
    return this.currentlyActiveTab === Teacher
  }

  get hasTeacherResource() {
    return this.args.bookSet.fields.books?.some((book) => {
      return book?.fields.role === Teacher
    })
  }

  get hasStudentResource() {
    return this.args.bookSet.fields.books?.some((book) => {
      return book?.fields.role === Student
    })
  }

  get inActiveColorClass() {
    const isReading = this.args.subscriptionType === SubscriptionType.Reading
    return isReading ? 'bg-oceany-blue-50' : 'bg-ms-green-50'
  }

  @action
  switchActiveTab(role: PrintablesBookRole) {
    if (role !== this.currentlyActiveTab) {
      this.currentlyActiveTab = role
    }
  }
  <template>
    <div class="flex flex-col" ...attributes>
      <div class="relative -bottom-0.5 inline-flex w-full">
        {{#if this.hasStudentResource}}
          <button
            type="button"
            class="border-dusty-black-50 text-dusty-black-300 mr-1 w-24 rounded-t-md border-2 border-b-0 p-2 text-center
              {{if this.studentResourceTabIsActive 'bg-white' this.inActiveColorClass}}"
            {{on "click" (fn this.switchActiveTab PrintablesBookRole.Student)}}
          >
            {{t "printables.student"}}
          </button>
        {{/if}}
        {{#if this.hasTeacherResource}}
          <button
            type="button"
            class="border-dusty-black-50 text-dusty-black-300 w-24 rounded-t-md border-2 border-b-0 p-2 text-center
              {{if this.teacherResourceTabIsActive 'bg-white' this.inActiveColorClass}}"
            {{on "click" (fn this.switchActiveTab PrintablesBookRole.Teacher)}}
          >
            {{t "printables.teacher"}}
          </button>
        {{/if}}
      </div>

      <ResourceCardBook
        class="flex grow flex-col"
        @bookSet={{@bookSet}}
        @role={{if this.studentResourceTabIsActive PrintablesBookRole.Student PrintablesBookRole.Teacher}}
        @subscriptionType={{@subscriptionType}}
      />
    </div>
  </template>
}

export default ResourceCard
